import {ThreadDrawerProvider} from "@/features/thread-drawer"
import ArchivePage from "@/pages/ArchivePage"

function Archive() {
  return (
    <ThreadDrawerProvider>
      <ArchivePage />
    </ThreadDrawerProvider>
  )
}

export default Archive
